import React from 'react';
import { Link } from 'react-router-dom';

import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';

import EzyLogo from '../../images/ezy-logo.png';
import BgImage from '../../images/bg.jpg';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const HELP = 'Please try again or if this issue persist contact helpdesk@ezycollect.com.au';

const DISCONNECT_STEPS = [
  'Click the organisation or practice name, then select Settings.',
  'Click Connected apps.',
  'Under Connected apps, click Disconnect beside ezyCollect.',
  'Click Disconnect to confirm.',
];

// Keyed by the reason code the registration backend adds to /error/xero?reason=...
const XERO_ERRORS = {
  already_connected: {
    title: 'This Xero organisation is already connected',
    msg:
      'An existing ezyCollect file is already connected to this Xero organisation. To start a new registration, ' +
      'first disconnect ezyCollect from Xero:',
    steps: DISCONNECT_STEPS,
    after: 'Then come back and register again.',
    retry: true,
  },
  still_connected: {
    title: 'This Xero organisation is still connected',
    msg:
      'An existing ezyCollect file is still connected to this Xero organisation. Disconnect ezyCollect in Xero ' +
      'first, or contact helpdesk@ezycollect.com.au:',
    steps: DISCONNECT_STEPS,
    after: 'Then come back and register again.',
    retry: true,
  },
  multiple_organisations: {
    title: 'Please connect one Xero organisation',
    msg: 'More than one Xero organisation was selected. Please register one organisation at a time.',
    retry: true,
  },
};

// Keyed by the reason code the registration backend adds to /error/arlive?reason=...
const ARLIVE_ERRORS = {
  expired: {
    title: 'Your MYOB connection has expired',
    msg: 'Please connect to MYOB again to continue your registration.',
    retryTo: '/arlive',
    retryLabel: 'Connect to MYOB',
  },
  cancelled: {
    title: 'MYOB access was not granted',
    msg: 'ezyCollect needs access to your AccountRight Live company file. Please connect to MYOB again and allow access.',
    retryTo: '/arlive',
    retryLabel: 'Connect to MYOB',
  },
};

const errorFor = (provider, search) => {
  const reason = new URLSearchParams(search).get('reason');
  if (provider === 'xero') {
    return XERO_ERRORS[reason] || { title: 'Authentication failed', msg: HELP };
  }
  if (provider === 'arlive') {
    return ARLIVE_ERRORS[reason] || {
      title: 'Authentication failed',
      msg: HELP,
      retryTo: '/arlive',
      retryLabel: 'Connect to MYOB',
    };
  }
  return { title: 'Something goes wrong', msg: HELP };
};

const ErrorPage = props => {
  const errorMsg = errorFor(props.match.params.provider, props.location.search);

  return (
    <div>
      <div className="main">
        <div className="side" style={{ background: `url(${BgImage}) 64% center no-repeat` }}>
          <div className="ezy-logo">
            <img src={EzyLogo} alt="ezyCollect" />
          </div>
        </div>
        <div className="content">
          <Box component="div" m={4} color="text.secondary">
            <Typography variant="h6" component="h6" className="ez-text-center">
              {errorMsg.title}
            </Typography>
          </Box>
          <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <ErrorIcon style={{ color: 'rgb(250 168 54)', fontSize: '10rem' }}></ErrorIcon>
            </div>
            <Grid item xs={12} style={{ textAlign: 'center', padding: '20px', color: '#335266' }}>
              <Typography variant="body2" gutterBottom>
                {errorMsg.msg}
              </Typography>
              {errorMsg.steps && (
                <ol style={{ textAlign: 'left', display: 'inline-block', margin: '12px auto' }}>
                  {errorMsg.steps.map(step => (
                    <li key={step}>
                      <Typography variant="body2">{step}</Typography>
                    </li>
                  ))}
                </ol>
              )}
              {errorMsg.after && (
                <Typography variant="body2" gutterBottom>
                  {errorMsg.after}
                </Typography>
              )}
              {(errorMsg.retry || errorMsg.retryTo) && (
                <Box mt={2}>
                  <Button variant="contained" color="primary" component={Link} to={errorMsg.retryTo || '/xero'}>
                    {errorMsg.retryLabel || 'Register again'}
                  </Button>
                </Box>
              )}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ErrorPage;
